import type { Draft } from 'immer';
import { useImmer } from 'use-immer';
import useConstant from 'use-constant';
import type { CustomButton } from '@types';

export default function useCustomButtonEditing(initialState?: CustomButton[]): {
  state: CustomButton[];
  setState: (
    f: (draft: Draft<CustomButton[]>) => void | CustomButton[]
  ) => void;
  isChanged: boolean;
} {
  const [state, setState] = useImmer<CustomButton[]>(() => initialState ?? []);
  const firstState = useConstant(() => state);
  const isChanged = firstState !== state;
  return { state, setState, isChanged };
}
